<template>
  <VuePhoneNumberInput :options="options" v-bind="context.attributes" :value="value" @update="handleChange" color="#D1D5DB" />
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  components: {
    VuePhoneNumberInput: () => import('vue-phone-number-input'),
  },
  computed: {
    local() {
      return this.context.local || 'ES';
    },
    color() {
      return this.context.color || 'dogderblue';
    },
    validColor() {
      return this.context.validColor || 'yellowgreen';
    },
    errorColor() {
      return this.context.errorColor || 'orangered';
    },
    size() {
      return this.context.size;
    },
    defaultCountryCode() {
      return this.context.defaultCountryCode || 'ES';
    },
    preferredCountries() {
      return this.context.preferredCountries || ['es-ES'];
    },
    ignoredCountries() {
      return this.context.ignoredCountries || null;
    },
    onlyCountries() {
      return this.context.onlyCountries || null;
    },
    noValidatorState() {
      return this.context.noValidatorState || false;
    },
    noFlags() {
      return this.context.noFlags || false;
    },
    disabled() {
      return this.context.disabled || false;
    },
    dark() {
      return this.context.dark || false;
    },
    darkColor() {
      return this.context.darkColor || '#424242';
    },
    translations() {
      return this.context.translations || false;
    },
    countriesHeight() {
      return this.context.countriesHeight || 30;
    },
    noUseBrowserLocale() {
      return this.context.noUseBrowserLocale || false;
    },
    fetchCountry() {
      return this.context.attributes.fetchCountry || false;
    },
    noCountrySelector() {
      return this.context.noCountrySelector || false;
    },
    borderRadius() {
      return this.context.borderRadius || 4;
    },
    showCodeOnList() {
      return this.context.showCodeOnList || false;
    },
    noExample() {
      return this.context.noExample || false;
    },
    required() {
      return this.context.attributes.required || false;
    },
    error() {
      return this.context.error || false;
    },
    clearable() {
      return this.context.clearable || false;
    },
    options() {
      return {
        color: this.color,
        validColor: this.validColor,
        errorColor: this.errorColor,
        size: this.size,
        preferredCountries: this.preferredCountries,
        ignoredCountries: this.ignoredCountries,
        onlyCountries: this.onlyCountries,
        noValidatorState: this.noValidatorState,
        noFlags: this.noFlags,
        disabled: this.disabled,
        dark: this.dark,
        darkColor: this.darkColor,
        translations: this.translations,
        countriesHeight: this.countriesHeight,
        noUseBrowserLocale: this.noUseBrowserLocale,
        fetchCountry: this.fetchCountry,
        defaultCountryCode: this.defaultCountryCode,
        noCountrySelector: this.noCountrySelector,
        borderRadius: this.borderRadius,
        showCodeOnList: this.showCodeOnList,
        noExample: this.noExample,
        required: this.required,
        error: this.error,
        clearable: this.clearable,
      };
    },
    value() {
      if (!!this.context.model) {
        return this.context.model.phone ? this.context.model.phone : this.context.model;
      } else {
        return '';
      }
    },
  },
  methods: {
    handleChange(e) {
      //TODO eventualmente coger el prefijo seteandólo en el context.model
      if (!!e.phoneNumber) e.phoneNumber = e.phoneNumber.replace('.', '').replace(' ', '');

      this.context.model = { prefix: e.countryCallingCode, isValid: e.isValid, phone: e.phoneNumber };

      if (!e.phoneNumber) this.context.model = '';

      this.$emit('change');
    },
  },
};
</script>

<style lang="postcss">
@import 'vue-phone-number-input/dist/vue-phone-number-input.css';
</style>

<style lang="postcss" scoped>
.vue-phone-number-input::v-deep {
  .country-selector {
    @apply z-[5];
    &__list {
      &__item {
        @apply text-neutral-semidark;

        &.selected {
          @apply !bg-support-medium text-neutral-white;
        }
      }
    }
    &__label {
      @apply hidden;
    }
    &__input {
      @apply rounded-r-none text-neutral-semidark border-solid border-hairline border-neutral-semilight;

      .formulate-input[data-is-showing-errors='true'] & {
        @apply !border-feedback-error-medium;
      }
    }
    &__toggle {
      @apply !top-1/3;

      svg path.arrow {
        --support-dark: #009afa;
        fill: var(--support-dark);
      }
    }
  }
  .input-tel {
    &[data-v-e59be3b4] {
      @apply !h-fit;
    }
    &__label {
      @apply hidden hover:cursor-text;
    }
    &__input[data-v-e59be3b4] {
      @apply px-xxxs !pt-micro hover:cursor-text border-solid border-l-none border-hairline border-neutral-semilight;

      .formulate-input[data-is-showing-errors='true'] & {
        @apply !border-feedback-error-medium;
      }
    }
  }
  .select-country-container[data-v-19c9a1c7] {
    @apply flex-none w-xxl min-w-[unset];
  }
  input {
    @apply style-body-sm py-micro !shadow-none h-auto min-h-fit !outline-none;

    &[data-v-46e105de].country-selector__input {
      @apply pt-micro pr-[1.873rem];

      .formulate-input[data-is-showing-errors='true'] & {
        @apply !border-feedback-error-medium;
      }
    }
  }
}
</style>
